import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

const MContainer = styled(Container)(({ theme }) => ({
  padding: '0 48px !important',
  [theme.breakpoints.down('sm')]: {
    padding: '0 24px !important'
  }
}));

export default MContainer;
